import ChannelConfig from '../cms/channel/ChannelConfig';

export default {
    computed: {
        generalChannel() {
            return this.channel.kind === ChannelConfig.CHANNEL_KIND.GENERAL;
        },
        programChannel() {
            return this.useFileToLive && this.channel.kind === ChannelConfig.CHANNEL_KIND.PROGRAMMING;
        },
        webrtcChannel() {
            return this.useWebRtc && this.channel.kind === ChannelConfig.CHANNEL_KIND.WEBRTC;
        },
        cmafChannel() {
          return this.useCmaf && this.channel.kind === ChannelConfig.CHANNEL_KIND.CMAF;
        },
        isOnAir() {
            return typeof this.channel !== 'undefined'
                && 'latest_live_media_broadcast' in this.channel
                && 'is_onair' in this.channel.latest_live_media_broadcast
                && this.channel.latest_live_media_broadcast.is_onair;
        },
    },
};
